import "./App.scss";
import "./App-rtl.scss";
import "./styles/scss/Navbar/Navbar.scss";

import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { NavProgressProvider } from "./components/context/navContext";
import IsMobileProvider from "./components/context/isMobileContext";
import Strategy from "./pages/Strategy";
import Appendices from "./pages/Appendices";
import Services from "./pages/Services";
import People from "./pages/People";
import Community from "./pages/community";
import Environment from "./pages/Environment";

function App() {
	const { i18n } = useTranslation();
	const [enteredView, setEnteredView] = useState(false);
	const [pageLoaded, setPageLoaded] = useState(false);
	// Re-render page & change dir after language change
	useEffect(() => {
		document.documentElement.dir = i18n.dir();
		document.documentElement.lang = i18n.language;
	}, [i18n.language]);

	const location = useLocation();
      useEffect(() => {
        if (location.pathname) {
          setPageLoaded(false);
          setTimeout(() => {
              setPageLoaded(true)
          }, 100);
        }
      }, [location])
	

	return (
		<div className="App">
			{/* <BrowserRouter basename="ajman-sustainability-report"> */}
				<Layout>
					<IsMobileProvider>
						<NavProgressProvider
							value={{
								enteredView,
								setEnteredView,
								pageLoaded,
								setPageLoaded,
							}}
						>
							<Navbar />
							<Routes>
								<Route path={``} exact element={<Home />} />
								<Route path={`/strategy`} exact element={<Strategy />} />
								<Route path={`/our-awards-and-certifications`} element={<Appendices/>} />
								<Route path={`/achievements/services`} element={<Services/>} />
								<Route path={`/achievements/people`} element={<People/>} />
								<Route path={`/achievements/community`} element={<Community/>} />
								<Route path={`/achievements/environment`} element={<Environment/>} />
							</Routes>
							<Footer />
						</NavProgressProvider>
					</IsMobileProvider>
				</Layout>
			{/* </BrowserRouter> */}
		</div>
	);
}

export default App;
